import React, { useState } from 'react';
import { AccordionItemHeading, AccordionItemButton } from 'react-accessible-accordion';
import Actions from './props/Actions';

const SMS = (props) => {
    let { activity, activityData, onUpdateActivity } = props;
    let [hovered, setHovered] = useState(false);

    const getStatusBackgroundColor = (status) => {
        const colors = {
            'completed': '#F0FDF4',
            'pending': '#FFF6F2',
            'cancelled': '#FFF2F2',
            'in-progress': '#EFF6FF'
        };
        return colors[status] || '#6c757d';
    };

    const getStatusColor = (status) => {
        const colors = {
            'completed': '#16A34A',
            'pending': '#EA580C',
            'cancelled': '#EA580C',
            'in-progress': '#2563EB'
        };
        return colors[status] || '#6c757d';
    };

    const getPriorityBackgroundColor = (priority) => {
        const colors = {
            'urgent': '#FFF2F2',
            'high': '#FFF6F2',
            'medium': '#EFF6FF',
            'low': '#6c757d'
        };
        return colors[priority] || '#6c757d';
    };
    const getPriorityColor = (priority) => {
        const colors = {
            'urgent': '#EF4D56',
            'high': '#EA580C',
            'medium': '#2563EB',
            'low': '#6c757d'
        };
        return colors[priority] || '#6c757d';
    };

    const getMessagePreview = () => {
        if (activity?.description) {
            const plainText = activity.description.replace(/<[^>]*>/g, '');
            return plainText.length > 100 ? plainText.substring(0, 100) + '...' : plainText;
        }
        return 'SMS message sent';
    };

    return (
        <>
            <AccordionItemHeading>
                <AccordionItemButton>
                    <div className="activity-card sms-card">
                        <div className="activity-header">
                            <div className="activity-type-info">
                                <div className="activity-icon sms-icon">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor" />
                                        <path d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H13V17H7V15Z" fill="currentColor" />
                                    </svg>
                                </div>
                                <div className="activity-details">
                                    <div className="activity-title">
                                        <span className="activity-type-label">SMS</span>
                                        <span className="activity-subject">
                                            {activity?.phoneNumber || activity?.metadata?.recipient || 'SMS sent'}
                                        </span>
                                    </div>
                                    <div className="activity-meta">
                                        <span className="created-by">by {activityData?.createdBy}</span>
                                        <div className="activity-badges">
                                            <span
                                                className="status-badge"
                                                style={{ backgroundColor: getStatusBackgroundColor(activity?.status), color: getStatusColor(activity?.status) }}
                                            >
                                                {activity?.status || 'completed'}
                                            </span>
                                            <span
                                                className="priority-badge"
                                                style={{ backgroundColor: getPriorityBackgroundColor(activity?.priority), color: getPriorityColor(activity?.status) }}
                                            >
                                                {activity?.priority || 'medium'}
                                            </span>
                                            {activity?.metadata?.source && (
                                                <span
                                                    className="source-badge"
                                                    style={{
                                                        backgroundColor: activity.metadata.source === 'manual' ? '#6c757d' : '#007bff',
                                                        color: '#fff',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px',
                                                        fontSize: '11px',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    {activity.metadata.source === 'manual' ? 'Manual' : 'Workflow'}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="activity-actions" onClick={(e) => e.stopPropagation()}>
                                <Actions {...props} />
                                <span className="activity-time">{activityData?.createdAt}</span>
                            </div>
                        </div>

                        <div className="sms-preview">
                            <div className="message-bubble">
                                {getMessagePreview()}
                            </div>
                        </div>

                        {activity?.metadata && (
                            <div className="activity-metadata">
                                {activity.metadata.messageId && (
                                    <div className="metadata-item">
                                        <strong>Message ID:</strong> {activity.metadata.messageId}
                                    </div>
                                )}
                                {activity.metadata.workflowId && (
                                    <div className="metadata-item">
                                        <strong>Via Workflow</strong>
                                        <span className="workflow-badge">Automated</span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </AccordionItemButton>
            </AccordionItemHeading>
        </>
    );
};

export default SMS;